import { schema } from "normalizr";
import { PageLayout as Record } from "records/page";
import { PageLayoutComponentsSchema } from "./page-layout-components";

export const PageLayoutSchema = new schema.Entity("pageLayouts", {
    components: PageLayoutComponentsSchema,
});

(PageLayoutSchema as any).record = Record;
